// extracted by mini-css-extract-plugin
export var page1 = "page1-module--page1--Keo0D";
export var finish = "page1-module--finish--sjtS0";
export var animation = "page1-module--animation--CRjWO";
export var logo = "page1-module--logo--LrNWC";
export var navigation = "page1-module--navigation--z2Yt5";
export var typo = "page1-module--typo--fC4dk";
export var introEn = "page1-module--introEn--pTVWj";
export var introKo2 = "page1-module--introKo2--rPgPT";
export var introEn2 = "page1-module--introEn2--mraCD";